import AppShell from "@/components/layout/AppShell";
import PageHeader from "@/components/ui/PageHeader";
import { Table, TD, TH, THead } from "@/components/ui/Table";
import { store } from "@/lib/store";
import { peso } from "@/lib/utils";

export default function CustomersPage() {
    const customers = store.getCustomers();

    return (
        <AppShell>
            <PageHeader title="Customers" description="Track repeat buyers and customer details." />
            <Table>
                <table className="min-w-full border-collapse">
                    <THead>
                        <tr>
                            <TH>Name</TH>
                            <TH>Mobile</TH>
                            <TH>Address</TH>
                            <TH>Total Orders</TH>
                            <TH>Total Spend</TH>
                        </tr>
                    </THead>
                    <tbody>
                        {customers.map((customer) => (
                            <tr key={customer.id} className="border-t border-rose-50">
                                <TD>{customer.name}</TD>
                                <TD>{customer.mobile}</TD>
                                <TD>{customer.address}</TD>
                                <TD>{customer.totalOrders}</TD>
                                <TD>{peso(customer.totalSpend)}</TD>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Table>
        </AppShell>
    );
}